'use client';

import React from 'react';
import type { ChatMessage } from '@/lib/api-client';
import { useTimezone } from '@/hooks/useTimezone';

interface MessageBubbleProps {
  message: ChatMessage;
  isOwn: boolean;
}

function formatTime(dateStr: string, tz: string) {
  const d = new Date(dateStr);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZone: tz });
}

export default function MessageBubble({ message, isOwn }: MessageBubbleProps) {
  const tz = useTimezone();
  if (message.senderType === 'system') {
    return (
      <div className="flex justify-center py-1.5">
        <span className="text-[11px] text-fg-subtle bg-card-hover-bg px-3 py-1 rounded-full">
          {message.body}
        </span>
      </div>
    );
  }

  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-2`}>
      <div className={`max-w-[80%] rounded-2xl px-3.5 py-2 ${
        isOwn
          ? 'bg-sky-600 text-white rounded-br-md'
          : 'bg-card-hover-bg text-slate-200 rounded-bl-md'
      }`}>
        {!isOwn && message.senderName && (
          <div className="text-[10px] font-medium text-sky-400 mb-0.5">{message.senderName}</div>
        )}
        <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">{message.body}</p>
        <div className={`text-[10px] mt-1 ${isOwn ? 'text-sky-200' : 'text-fg-subtle'} text-right`}>
          {formatTime(message.createdAt, tz)}
          {isOwn && message.readAt && <span className="ml-1">Read</span>}
        </div>
      </div>
    </div>
  );
}
